import { useState, useEffect, useCallback } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import '../vendorProfile/profile.css'
import avatar from '../../assets/avatar.png'
import BannderDeciderContainer from '../vendorProfile/BannderDeciderContainer';
import enquire from '../../assets/icons/enquire.png'
import details from '../../assets/icons/details.png'
import '../businessAnalysis/businessAnalysis.css'
import { Link } from 'react-router-dom';
import { useUserAuth } from '../../context/UserAuthContext';
import axios from 'axios';

const InvoiceMgmt = () => {
    const { user, language, token } = useUserAuth();
    const merchant_id = user?.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState([]);
    const [loading, setLoading] = useState(false);
    const getSingleDocumentHandler = useCallback(async (merchant_id, setMerchant, setLoading) => {
        if (!merchant_id) return;
        setLoading(true);
        try {
            const { data } = await axios.get(`${base_url}/api/v1/users/id/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setMerchant(data?.data || {});
        } catch (error) {
            console.error("Error fetching merchant data:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getSingleDocumentHandler(merchant_id, setMerchant, setLoading);
    }, [merchant_id, getSingleDocumentHandler, token]);

    const [box, setBox] = useState(
        [
            {
                title: 'Create Invoice',
                hindiTitle: "नया बिल बनाएं",
                quatity: '343',
                url: details,
                href: "/dashboard/invoice-create"
            },
            {
                title: 'Invoice List',
                hindiTitle: "बिल बुक सूची",
                quatity: '70',
                url: enquire,
                href: "/dashboard/invoice-list"
            },
            {
                title: 'Manage Item /  Services',
                hindiTitle: "मैनेज वस्तु/सर्विस",
                quatity: '70',
                url: enquire,
                href: "/dashboard/invoice-item"
            },
            {
                title: 'Manage T & C',
                hindiTitle: "नियम और शर्तें",
                quatity: '343',
                url: enquire,
                href: "/dashboard/invoice-terms"
            },
            {
                title: 'Manage Bank Details',
                hindiTitle: "बैंक डीटेल्स",
                quatity: '343',
                url: enquire,
                href: "/dashboard/invoice-basic"
            },
        ])
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='profileHeader'>
                                                <div className='card'>
                                                    {
                                                        loading ? <Skeleton count={1} height={180} /> :
                                                            (
                                                                <>
                                                                    <div className='card-header imgBannerParent bg-white m-0 p-0'>
                                                                        <BannderDeciderContainer subCatId={merchant?.sub_category_id} />
                                                                    </div>
                                                                    <div className='card-body imgProfileParent'>
                                                                        <img
                                                                            src={merchant?.profilePicture?.image || avatar}
                                                                            className='profileImages' alt="" />
                                                                        <h1
                                                                            style={{ fontWeight: "bold", color: "#41B0FA" }}
                                                                            className="business-name"
                                                                        >
                                                                            {merchant?.business_name}&nbsp;
                                                                        </h1>
                                                                    </div>
                                                                </>
                                                            )
                                                    }
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className='row'>
                                                                    {
                                                                        box.map((cur, index) => {
                                                                            return (
                                                                                <div className='col-md-3 col-6' key={index} >
                                                                                    <Link to={cur.href}>
                                                                                        <div className=" p-10  text-center total_card shadow-sm">
                                                                                            <div className='data d-flex justify-content-center'>
                                                                                                <img src={cur.url} className='dash_icon' alt="Event Planet" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                                                                                            </div>
                                                                                            <p className=" p-2" style={{ fontWeight: '600', fontSize: '15px', color: "#000" }}>
                                                                                                {language === 'en' ? cur.title : cur.hindiTitle}</p>
                                                                                        </div>
                                                                                    </Link>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceMgmt